// @ts-nocheck
import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { apiEditMatchV2 } from "../../../api/matchApi";
import colors from "../../../styles/colors";

// Styled components (condivisi con CreateMatchModale)
const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
`;

const ModalDialog = styled.div`
    position: relative;
    width: 100%;
    max-width: 800px;
    margin: 28px auto;
    pointer-events: none;
`;

const ModalContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: ${colors.bgColorBlack2};
    color: white;
    background-clip: padding-box;
    border: 5px solid gold;
    border-radius: 5px;
    outline: 0;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    max-height: 95vh;
    overflow-y: auto;
`;

const ModalHeader = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    padding: 16px;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    gap: 12px;
`;

const ModalHeaderTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

const ModalTitle = styled.h5`
    margin: 0;
    line-height: 1.5;
    font-size: 21px;
    font-weight: 500;
    color: gold;
`;

const PpvInfo = styled.div`
    font-size: 15px;
    color: rgba(255, 255, 255, 0.8);
    font-style: italic;
    text-align: center;
    padding: 8px;
    background-color: ${colors.bgColorBlack};
    border-radius: 4px;
`;

const CloseButton = styled.button`
    box-sizing: content-box;
    width: 1em;
    height: 1em;
    padding: 4px;
    color: white;
    border: 0;
    border-radius: 4px;
    opacity: 0.5;
    background: transparent;
    cursor: pointer;
    font-size: 25px;
    font-weight: 700;
    line-height: 1;
    text-shadow: 0 1px 0 #fff;
    
    &:hover {
        opacity: 0.75;
    }
    
    &:before {
        content: "×";
    }
`;

const ModalBody = styled.div`
    position: relative;
    flex: 1 1 auto;
    padding: 16px;
`;

const ModalFooter = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-shrink: 0;
    align-items: center;
    justify-content: flex-end;
    padding: 12px;
    border-top: 1px solid #dee2e6;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    gap: 8px;
`;

const FormGroup = styled.div`
    margin-bottom: 16px;
`;

const FormLabel = styled.label`
    display: inline-block;
    margin-bottom: 8px;
    font-weight: 500;
    color: gold;
`;

const FormInput = styled.input`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 17px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    
    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
    
    &:disabled {
        background-color: #e9ecef;
        opacity: 1;
    }
`;

const FormTextarea = styled.textarea`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 17px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    resize: vertical;
    min-height: 60px;
    
    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
`;

const FormSelect = styled.select`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 17px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    
    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
`;

const Button = styled.button`
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    color: #ffffff;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 6px 12px;
    font-size: 17px;
    border-radius: 4px;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    
    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }
`;

const ButtonPrimary = styled(Button)`
    color: white;
    background-color: #0d6efd;
    border-color: #0d6efd;
    
    &:hover:not(:disabled) {
        color: white;
        background-color: #0b5ed7;
        border-color: #0a58ca;
    }
    
    &:focus {
        color: #ffffff;
        background-color: #0b5ed7;
        border-color: #0a58ca;
        box-shadow: 0 0 0 4px rgba(49, 132, 253, 0.5);
    }
`;

const ButtonSecondary = styled(Button)`
    color: #ffffff;
    background-color: #6c757d;
    border-color: #6c757d;
    
    &:hover:not(:disabled) {
        color: #ffffff;
        background-color: #5c636a;
        border-color: #565e64;
    }
    
    &:focus {
        color: #ffffff;
        background-color: #5c636a;
        border-color: #565e64;
        box-shadow: 0 0 0 4px rgba(130, 138, 145, 0.5);
    }
`;

const ErrorText = styled.p`
    margin-top: 4px;
    margin-bottom: 0;
    color: #dc3545;
    font-size: 15px;
`;

const GeneralErrorText = styled.div`
    margin-bottom: 16px;
    padding: 12px;
    background-color: rgba(255, 193, 7, 0.1);
    border: 1px solid #ffc107;
    border-radius: 4px;
    color: #ffc107;
    font-size: 15px;
`;

const StatusMessage = styled.div`
    text-align: right;
    padding: 0 16px;
    margin-top: 8px;
    color: #000000;
`;

const SuccessText = styled.div`
    text-align: right;
    padding: 0 16px;
    margin-top: 8px;
    color: #198754;
`;

const DropdownContainer = styled.div`
    position: relative;
    width: 100%;
`;

const DropdownInputWrapper = styled.div`
    display: flex;
    gap: 8px;
    align-items: flex-start;
`;

const ResetButton = styled.button`
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    color: #ffffff;
    background-color: #6c757d;
    border: 1px solid #6c757d;
    border-radius: 4px;
    cursor: pointer;
    white-space: nowrap;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
    
    &:hover:not(:disabled) {
        color: #ffffff;
        background-color: #5c636a;
        border-color: #565e64;
    }
    
    &:focus {
        color: #ffffff;
        background-color: #5c636a;
        border-color: #565e64;
        box-shadow: 0 0 0 4px rgba(130, 138, 145, 0.5);
    }
    
    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }
`;

const DropdownInput = styled.input`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 17px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    
    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
    
    &:disabled {
        background-color: #e9ecef;
        opacity: 1;
    }
`;

const DropdownList = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: white;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    margin-top: 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const DropdownItem = styled.div`
    padding: 8px 12px;
    cursor: pointer;
    color: #000000;
    border-bottom: 1px solid #e9ecef;
    
    &:hover {
        background-color: #f8f9fa;
    }
    
    &:last-child {
        border-bottom: none;
    }
`;

const DropdownEmpty = styled.div`
    padding: 8px 12px;
    color: #6c757d;
    font-style: italic;
`;

// Funzione per formattare il tipo match (es: "five_tag" -> "Five Tag")
const formatTypeMatchType = (type: any) => {
    if (!type) return '';
    return type
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

// Funzione per ottenere l'anno dalla data
const getYearFromDate = (dateValue: any) => {
    if (!dateValue) return '';
    let date;
    if (typeof dateValue === 'number') {
        date = dateValue > 1e12 ? new Date(dateValue) : new Date(dateValue * 1000);
    } else if (typeof dateValue === 'string') {
        if (/^\d+$/.test(dateValue)) {
            const numValue = parseInt(dateValue);
            date = numValue > 1e12 ? new Date(numValue) : new Date(numValue * 1000);
        } else {
            date = new Date(dateValue);
        }
    } else {
        date = new Date(dateValue);
    }
    if (isNaN(date.getTime())) return '';
    return date.getFullYear();
};

function EditMatchModale({ ppvSpecific, ppvGeneraleName, typeMatchesList, onTypeMatchesLoad, editData, closeModalClick, onMatchCreated }) {
    const formRef = useRef(null);
    const [responseApiEditMatch, setResponseApiEditMatch] = useState({});
    const [errorsForm, setErrorsForm] = useState({});
    const [isLoadingForm, setIsLoadingForm] = useState(false);
    const [matchUpdated, setMatchUpdated] = useState(false);
    const [isFirstRendering, setIsFirstRendering] = useState(true);
    
    // Dropdown refs
    const stipulationDropdownRef = useRef(null);
    
    // Stipulation state
    const [stipulationSearch, setStipulationSearch] = useState('');
    const [selectedStipulation, setSelectedStipulation] = useState(null);
    const [showStipulationDropdown, setShowStipulationDropdown] = useState(false);
    const [filteredStipulations, setFilteredStipulations] = useState([]);
    const [availableStipulations, setAvailableStipulations] = useState([]);
    
    // Form state
    const [notes, setNotes] = useState('');
    const [importance, setImportance] = useState(1);
    
    // Carica i dati se non sono disponibili
    useEffect(() => {
        if ((!typeMatchesList || (typeof typeMatchesList === 'object' && !Array.isArray(typeMatchesList) && Object.keys(typeMatchesList).length === 0)) && onTypeMatchesLoad) {
            onTypeMatchesLoad();
        }
    }, [typeMatchesList, onTypeMatchesLoad]);
    
    // Popola i campi quando editData è presente
    useEffect(() => {
        if (editData) {
            const currentImportance = editData.importance !== undefined && editData.importance !== null ? editData.importance : 1;
            setImportance(currentImportance);
            setNotes(editData.notes || '');
            
            // Imposta il valore iniziale della stipulation se disponibile (prima che typeMatchesList sia caricato)
            if (editData.type_match && editData.type_match.name && !stipulationSearch) {
                setStipulationSearch(editData.type_match.name);
            }
        }
    }, [editData]);
    
    // Carica e trova la stipulation quando typeMatchesList è disponibile
    useEffect(() => {
        if (editData && editData.type_match && 
            typeMatchesList && typeof typeMatchesList === 'object' && !Array.isArray(typeMatchesList)) {
            const matchType = editData.type_match.type;
            // Le chiavi in typeMatchesList sono formattate (es: "Five Tag" invece di "five_tag")
            // Quindi devo formattare il tipo per trovare la chiave corretta
            const formattedType = formatTypeMatchType(matchType);
            
            console.log('Cercando stipulations per tipo:', {
                matchType,
                formattedType,
                availableKeys: Object.keys(typeMatchesList),
                hasFormattedType: !!typeMatchesList[formattedType]
            });
            
            if (formattedType && typeMatchesList[formattedType]) {
                const stipulations = typeMatchesList[formattedType];
                
                console.log('Stipulations trovate:', stipulations.length, stipulations.map(s => s.name));
                
                // Carica sempre le stipulations disponibili
                setAvailableStipulations(stipulations);
                setFilteredStipulations(stipulations);
                
                // Trova la stipulation usando il name del type_match (stipulation equivale a name di typematch)
                const matchStipulationName = editData.type_match.name;
                
                let foundStipulation = null;
                
                // Cerca per name (priorità)
                if (matchStipulationName) {
                    foundStipulation = stipulations.find(stip => stip.name === matchStipulationName);
                }
                
                // Se non trova per nome, prova con type_match_id come fallback
                if (!foundStipulation && editData.type_match_id) {
                    foundStipulation = stipulations.find(stip => stip.id === editData.type_match_id);
                }
                
                // Se trovata, imposta sia selectedStipulation che stipulationSearch
                if (foundStipulation) {
                    setSelectedStipulation(foundStipulation);
                    setStipulationSearch(foundStipulation.name);
                } else if (stipulations.length > 0) {
                    // Fallback: usa la prima disponibile se ce ne sono
                    setSelectedStipulation(stipulations[0]);
                    setStipulationSearch(stipulations[0].name);
                }
            } else {
                console.warn('Tipo match non trovato in typeMatchesList:', {
                    matchType,
                    formattedType,
                    availableKeys: Object.keys(typeMatchesList)
                });
            }
        }
    }, [editData, typeMatchesList]);
    
    // Filtra le stipulations
    useEffect(() => {
        if (!availableStipulations || availableStipulations.length === 0) {
            setFilteredStipulations([]);
            return;
        }
        
        if (!stipulationSearch || stipulationSearch.trim() === '') {
            setFilteredStipulations(availableStipulations);
        } else {
            const searchLower = stipulationSearch.toLowerCase();
            const filtered = availableStipulations.filter(stip => 
                stip.name.toLowerCase().includes(searchLower)
            );
            setFilteredStipulations(filtered);
        }
    }, [stipulationSearch, availableStipulations]);
    
    // Chiudi dropdown quando si clicca fuori
    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (stipulationDropdownRef.current && !stipulationDropdownRef.current.contains(event.target)) {
                setShowStipulationDropdown(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    
    const handleSubmit = async (event: any) => {
        setIsLoadingForm(true);
        setErrorsForm({});
        event.preventDefault();
        
        console.log('=== DEBUG handleSubmit ===');
        console.log('selectedStipulation:', selectedStipulation);
        console.log('editData:', editData);
        console.log('notes:', notes);
        console.log('importance:', importance);
        console.log('typeMatchesList:', typeMatchesList);
        
        // Usa sempre selectedStipulation se disponibile, altrimenti usa quella originale da editData
        let stipulationToUse = selectedStipulation;
        if (!stipulationToUse && editData && editData.type_match) {
            // Se non c'è una stipulation selezionata, cerca quella originale
            if (typeMatchesList && typeof typeMatchesList === 'object' && !Array.isArray(typeMatchesList)) {
                const matchType = editData.type_match.type;
                // Le chiavi in typeMatchesList sono formattate (es: "Five Tag" invece di "five_tag")
                const formattedType = formatTypeMatchType(matchType);
                if (formattedType && typeMatchesList[formattedType]) {
                    const stipulations = typeMatchesList[formattedType];
                    // Cerca per name del type_match (stipulation equivale a name di typematch)
                    const matchStipulationName = editData.type_match.name;
                    if (matchStipulationName) {
                        stipulationToUse = stipulations.find(stip => stip.name === matchStipulationName);
                    }
                    // Se non trova per nome, prova con type_match.id o type_match_id come fallback
                    if (!stipulationToUse) {
                        const matchId = editData.type_match.id || editData.type_match_id;
                        if (matchId) {
                            stipulationToUse = stipulations.find(stip => stip.id === matchId);
                        }
                    }
                }
            }
        }
        
        console.log('stipulationToUse dopo ricerca:', stipulationToUse);
        
        if (!stipulationToUse) {
            console.error('Stipulation non trovata!');
            setErrorsForm({ type_match_id: 'Stipulation non trovata. Ricarica la pagina e riprova.' });
            setIsLoadingForm(false);
            return;
        }
        
        // Usa i valori attuali se non sono stati modificati
        // notes: nullable, string, max:1000 - deve essere null se vuoto, altrimenti stringa
        const notesToSend = notes !== undefined && notes !== null && notes.trim() !== '' 
            ? notes.trim().substring(0, 1000) // Limita a 1000 caratteri
            : null;
        
        // importance: required, integer, min:1, max:10
        const importanceToSend = importance !== undefined && importance !== null 
            ? parseInt(importance, 10) 
            : (editData.importance ? parseInt(editData.importance, 10) : 1);
        
        // type_match_id: required, integer
        const typeMatchIdToSend = parseInt(stipulationToUse.id, 10);
        
        const body = {
            type_match_id: typeMatchIdToSend,
            importance: importanceToSend,
            notes: notesToSend
        };
        
        console.log('Body da inviare:', body);
        console.log('Match ID:', editData.id);
        
        try {
            const response = await apiEditMatchV2(body, editData.id);
            console.log('Response API:', response);
            setResponseApiEditMatch(response);
        } catch (error) {
            console.error('Errore durante la modifica del match:', error);
            const errorMessage = error?.response?.data?.error || error?.message || 'Si è verificato un errore durante la modifica del match. Riprova.';
            setResponseApiEditMatch({ error: errorMessage });
            setIsLoadingForm(false);
        }
    };
    
    useEffect(() => {
        if (!isFirstRendering && Object.keys(responseApiEditMatch).length > 0) {
            if (responseApiEditMatch.errors) {
                setErrorsForm(responseApiEditMatch.errors);
                setIsLoadingForm(false);
                setMatchUpdated(false);
            } else if (responseApiEditMatch.error) {
                setErrorsForm({ general: responseApiEditMatch.error });
                setIsLoadingForm(false);
                setMatchUpdated(false);
            } else {
                const hasSuccessIndicator = responseApiEditMatch.id || 
                                           responseApiEditMatch.data || 
                                           responseApiEditMatch.match ||
                                           (Object.keys(responseApiEditMatch).length > 0 && 
                                            !responseApiEditMatch.error && 
                                            !responseApiEditMatch.errors);
                
                if (hasSuccessIndicator && !matchUpdated) {
                    setIsLoadingForm(false);
                    setMatchUpdated(true);
                    if (onMatchCreated) {
                        onMatchCreated();
                    }
                }
            }
        } else if (isFirstRendering) {
            setIsFirstRendering(false);
        }
    }, [responseApiEditMatch, onMatchCreated, matchUpdated, isFirstRendering]);
    
    const handleCloseModal = () => {
        if (formRef.current) {
            formRef.current.reset();
        }
        setMatchUpdated(false);
        setErrorsForm({});
        setSelectedStipulation(null);
        setStipulationSearch('');
        setNotes('');
        setImportance(1);
        closeModalClick();
    };
    
    const handleStipulationSelect = (stipulation: any) => {
        setSelectedStipulation(stipulation);
        setStipulationSearch(stipulation.name);
        setShowStipulationDropdown(false);
    };
    
    const handleResetStipulation = () => {
        setStipulationSearch('');
        setSelectedStipulation(null);
        setFilteredStipulations(availableStipulations);
        setShowStipulationDropdown(true);
    };
    
    if (!editData || !editData.type_match) {
        return null;
    }
    
    return (
        <Container className="edit-match-modale-container">
            <ModalDialog className="edit-match-modale-dialog">
                <ModalContent className="edit-match-modale-content">
                    <form ref={formRef} onSubmit={handleSubmit} className="edit-match-modale-form">
                        <ModalHeader className="edit-match-modale-header">
                            <ModalHeaderTop className="edit-match-modale-header-top">
                                <ModalTitle className="edit-match-modale-title">
                                    Modifica Match
                                </ModalTitle>
                                <CloseButton type="button" aria-label="Close" onClick={handleCloseModal} className="edit-match-modale-close-button"></CloseButton>
                            </ModalHeaderTop>
                            <PpvInfo className="edit-match-modale-ppv-info">
                                {ppvGeneraleName} {getYearFromDate(ppvSpecific?.date)}
                            </PpvInfo>
                        </ModalHeader>
                        <ModalBody className="edit-match-modale-body">
                            {/* Messaggio informativo */}
                            <FormGroup className="edit-match-modale-form-group">
                                <GeneralErrorText>
                                    <strong>ATTENZIONE:</strong> In modalità modifica è possibile modificare solamente i seguenti campi: <strong>Importance</strong>, <strong>Stipulazione</strong> e <strong>Note</strong>. Se si ha intenzione di modificare altri parametri, bisogna eliminare il match e ricrearlo da zero.
                                </GeneralErrorText>
                            </FormGroup>
                            
                            {/* Type Match Display (non modificabile) */}
                            {editData.type_match && (
                                <FormGroup className="edit-match-modale-form-group">
                                    <FormLabel className="edit-match-modale-label">Tipo Match (non modificabile)</FormLabel>
                                    <FormInput 
                                        type="text"
                                        value={formatTypeMatchType(editData.type_match.type) || 'N/A'}
                                        disabled
                                        style={{ backgroundColor: colors.bgColorBlack2, color: 'rgba(255, 255, 255, 0.7)', fontStyle: 'italic', cursor: 'not-allowed' }}
                                    />
                                </FormGroup>
                            )}
                            
                            {/* Select Stipulation */}
                            {editData.type_match && (
                                <FormGroup className="edit-match-modale-form-group">
                                    <FormLabel htmlFor="stipulation" className="edit-match-modale-label">Stipulation *</FormLabel>
                                    <DropdownContainer ref={stipulationDropdownRef}>
                                        <DropdownInputWrapper>
                                            <DropdownInput
                                                type="text"
                                                id="stipulation"
                                                placeholder={
                                                    (availableStipulations && availableStipulations.length > 0)
                                                        ? "Cerca stipulation..."
                                                        : "Caricamento stipulations..."
                                                }
                                                value={stipulationSearch || ''}
                                                onChange={(e: any) => {
                                                    setStipulationSearch(e.target.value);
                                                    setShowStipulationDropdown(true);
                                                }}
                                                onFocus={() => {
                                                    if (availableStipulations && availableStipulations.length > 0) {
                                                        setShowStipulationDropdown(true);
                                                    }
                                                }}
                                                disabled={!availableStipulations || availableStipulations.length === 0}
                                                style={{ flex: 1 }}
                                            />
                                            <ResetButton
                                                type="button"
                                                onClick={handleResetStipulation}
                                                disabled={!availableStipulations || availableStipulations.length === 0}
                                            >
                                                Resetta
                                            </ResetButton>
                                        </DropdownInputWrapper>
                                        {showStipulationDropdown && filteredStipulations.length > 0 && (
                                            <DropdownList>
                                                {filteredStipulations.map((stipulation: any) => (
                                                    <DropdownItem 
                                                        key={stipulation.id}
                                                        onClick={() => handleStipulationSelect(stipulation)}
                                                    >
                                                        {stipulation.name}
                                                    </DropdownItem>
                                                ))}
                                            </DropdownList>
                                        )}
                                        {showStipulationDropdown && filteredStipulations.length === 0 && stipulationSearch && (
                                            <DropdownList>
                                                <DropdownEmpty>Nessuna stipulation trovata</DropdownEmpty>
                                            </DropdownList>
                                        )}
                                    </DropdownContainer>
                                    {errorsForm.type_match_id && <ErrorText className="edit-match-modale-error-text">{Array.isArray(errorsForm.type_match_id) ? errorsForm.type_match_id[0] : errorsForm.type_match_id}</ErrorText>}
                                </FormGroup>
                            )}
                            
                            {/* Importance (1-10) */}
                            <FormGroup className="edit-match-modale-form-group">
                                <FormLabel htmlFor="importance" className="edit-match-modale-label">Importance (1-10) *</FormLabel>
                                <FormLabel className="edit-match-modale-label" style={{ fontStyle: 'italic', color: 'rgba(255, 255, 255, 0.7)', fontSize: '14px', fontWeight: 'normal', marginTop: '-8px', marginBottom: '8px' }}>
                                    L'importanza del match (calcolata precedentemente con un algoritmo e qui si può forzare la modifica senza algoritmo) che andrà ad impattare soprattutto sulle statistiche del miglior lottatore.
                                </FormLabel>
                                <FormSelect 
                                    id="importance"
                                    value={importance}
                                    onChange={(e: any) => setImportance(parseInt(e.target.value))}
                                    required
                                >
                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(val => (
                                        <option key={val} value={val}>{val}</option>
                                    ))}
                                </FormSelect>
                                {errorsForm.importance && <ErrorText className="edit-match-modale-error-text">{Array.isArray(errorsForm.importance) ? errorsForm.importance[0] : errorsForm.importance}</ErrorText>}
                            </FormGroup>
                            
                            {/* Notes */}
                            <FormGroup className="edit-match-modale-form-group">
                                <FormLabel htmlFor="notes" className="edit-match-modale-label">Note</FormLabel>
                                <FormTextarea 
                                    id="notes" 
                                    name="notes" 
                                    className="edit-match-modale-textarea"
                                    value={notes}
                                    onChange={(e: any) => setNotes(e.target.value)}
                                    placeholder="Inserisci note (opzionale)"
                                />
                                {errorsForm.notes && <ErrorText className="edit-match-modale-error-text">{Array.isArray(errorsForm.notes) ? errorsForm.notes[0] : errorsForm.notes}</ErrorText>}
                            </FormGroup>
                            
                            {/* Errore generale */}
                            {errorsForm.general && (
                                <GeneralErrorText className="edit-match-modale-general-error">
                                    {Array.isArray(errorsForm.general) ? errorsForm.general[0] : errorsForm.general}
                                </GeneralErrorText>
                            )}
                        </ModalBody>
                        <ModalFooter className="edit-match-modale-footer">
                            <ButtonSecondary type="button" onClick={handleCloseModal} className="edit-match-modale-button-secondary">Chiudi</ButtonSecondary>
                            <ButtonPrimary type="submit" disabled={isLoadingForm || matchUpdated} className="edit-match-modale-button-primary">
                                {isLoadingForm ? 'Caricamento...' : 'Modifica Match'}
                            </ButtonPrimary>
                        </ModalFooter>
                        {isLoadingForm && <StatusMessage className="edit-match-modale-status-message">Caricamento..</StatusMessage>}
                        {matchUpdated && <SuccessText className="edit-match-modale-success-text">
                            Match modificato con successo!
                        </SuccessText>}
                    </form>
                </ModalContent>
            </ModalDialog>
        </Container>
    );
}

export default EditMatchModale;
